import { Field } from 'formik';
import { Input as SvpInput } from '@schibsted-svp/react-ui';

import { FormField } from '../shared/FormField/FormField';

import type { FC } from 'react';
import type { FieldProps } from 'formik';

type Props = {
  label: string;
  name: string;
  [key: string]: unknown;
};

const Input: FC<Props> = ({ label, ...props }) => {
  return (
    <FormField label={label}>
      <Field {...props}>
        {({ field, meta }: FieldProps) => (
          <SvpInput
            {...field}
            {...props}
            error={typeof meta.error === 'string' ? meta.error : undefined}
          />
        )}
      </Field>
    </FormField>
  );
};

export { Input };
